import { WORKSHEET_NO, WORKSHEET_YES } from '../../WorksheetFieldsLayout.constants';

export const WORKSHEET_YES_NO_VALUE = {
  YES: 'true',
  NO: 'false',
};

export const WORKSHEET_YES_NO_OPTIONS = [
  { value: WORKSHEET_YES_NO_VALUE.YES, label: WORKSHEET_YES },
  { value: WORKSHEET_YES_NO_VALUE.NO, label: WORKSHEET_NO },
];
